import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { NavItem } from 'react-bootstrap';
import { Switch, Route, Link, withRouter, Redirect } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import OpportunityOwnerPage from '../OpportunityOwnerPage/OpportunityOwnerPage';
import AccountOwnerPage from '../AccountOwnerPage/AccountOwnerPage';

class OwnerPagePage extends Component {
  constructor() {
    super();
    this.state = {
      
    };
  }

  render() {
    const { organization, location } = this.props;
    const isDemo = organization && organization.is_demo;

    const orgType = organization && organization.type;
    let accountObjectName = 'Account';
    if (orgType === 'hubspot') {
      accountObjectName = 'company';
    }
    
    let opportunityObjectName = 'Opportunity';
    if (orgType === 'hubspot') {
      opportunityObjectName = 'deal';
    }

    let resourceName = opportunityObjectName;
    if (location.pathname === '/setup/owner/account') {
      resourceName = accountObjectName;
    }


    return (
      <div>
        <Helmet title="Manage Custom Owner Field" />
        <div className="container">
          {!isDemo &&
            <div className="well well-sm">
              <div>
                <p>
                  If you are not using the default Opportunity/Account Owner field and are using a custom field for the Opportunity/Account Owner, 
                  select the appropriate custom field below. 
                </p>
                <p>
                  If you do not see the correct custom field, ensure that you have enabled the field in <Link to={`/setup/sync-settings/${resourceName}`}>Sync Settings</Link>. 
                  If the field has not been enabled in <Link to={`/setup/sync-settings/${resourceName}`}>Sync Settings</Link> it will not be displayed as an option here.
                </p>
              </div>
            </div>
          }
          {isDemo &&
            <div className="alert alert-warning">
              This is a demo organization, please switch back to the original organization to change the settings.
            </div>
          }
          {!isDemo &&
            <div>
              <ul className="nav nav-tabs">
                <LinkContainer exact to="/setup/owner/opportunity">
                  <NavItem>Opportunity Owner</NavItem>
                </LinkContainer>
                <LinkContainer exact to="/setup/owner/account">
                  <NavItem>Account Owner</NavItem>
                </LinkContainer>
              </ul>
              <p />
            </div>
          }
        </div>
        {!isDemo &&
          <Switch>
            <Route path="/setup/owner/opportunity" component={OpportunityOwnerPage} />
            <Route path="/setup/owner/account" component={AccountOwnerPage} />
            {(location.pathname === '/setup/owner' && <Redirect to="/setup/owner/opportunity" />)}
          </Switch>
        }
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

OwnerPagePage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  organization: PropTypes.shape({}).isRequired,
};

OwnerPagePage.contextTypes = {
};

export default connect(mapStateToProps)(withRouter(OwnerPagePage));
